import React, { useState, useEffect } from 'react';
import { Sparkles, RefreshCw } from 'lucide-react';
import { quotesAPI } from '../services/api';

const MotivationalQuote = () => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    loadQuote();
  }, []);

  const loadQuote = async () => {
    try {
      setLoading(true);
      const data = await quotesAPI.getDaily();
      setQuote(data);
    } catch (error) {
      console.error('Error loading quote:', error);
      setQuote({
        quote: "Every step forward is progress. Keep building your habits!",
        generated: false
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      const data = await quotesAPI.getDaily();
      setQuote(data);
    } catch (error) {
      console.error('Error refreshing quote:', error);
    } finally {
      setRefreshing(false);
    }
  };

  if (loading) {
    return (
      <div className="gradient-card rounded-2xl p-6 border border-white/20 dark:border-white/10">
        <div className="animate-pulse flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-700"></div>
          <div className="flex-1 h-4 bg-slate-200 dark:bg-slate-700 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="relative gradient-card rounded-2xl p-6 border border-white/20 dark:border-white/10 overflow-hidden"
      data-testid="motivational-quote"
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-500/10 to-pink-500/10 rounded-full blur-2xl"></div>
      
      <div className="relative flex items-start gap-4">
        {/* Icon */}
        <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center">
          <Sparkles className="w-6 h-6 text-purple-500" />
        </div>
        
        {/* Quote */}
        <div className="flex-1 min-w-0">
          <p className="text-lg font-medium text-slate-700 dark:text-slate-200 leading-relaxed">
            &ldquo;{quote?.quote}&rdquo;
          </p>
          {quote?.generated && (
            <p className="mt-2 text-xs text-slate-400 dark:text-slate-500">
              ✨ AI-powered motivation, just for you
            </p>
          )}
        </div>

        {/* Refresh button */}
        <button
          onClick={handleRefresh}
          disabled={refreshing}
          className="flex-shrink-0 p-2 text-slate-400 hover:text-purple-500 hover:bg-purple-500/10 rounded-lg transition-all duration-200"
          title="Get new quote"
        >
          <RefreshCw className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} />
        </button>
      </div>
    </div>
  );
};

export default MotivationalQuote;
